// Root font size which the rems are referencing is set by a global style in global-styles.ts
export const REPORT_LAB_FONT_BODY = 'calc(1rem * 8 / 9)';
export const REPORT_LAB_FONT_COMPACT = '0.525rem';
